import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { ContractTypeService } from '../proxy/controlling/controllers/contract-type.service';
import { PropertyTypeService } from '@planning/proxy/planning/controllers/property-type.service';
FieldBuilder.setNamespace('Controlling');

export const CONTRACTTYPEPERPROPERTYTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('contractTypeId', 'Entity.ContractType', ContractTypeService)
    .displayFromNested('contractType.name')
    .sortBy('contractType.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('propertyTypeId', 'Entity.ContractTypePerPropertyType.PropertyType', PropertyTypeService)
    .display('name')
    .keyField('id')
    .build(),
];

export const CONTRACTTYPEPERPROPERTYTYPE_CONFIG = {
  entityName: 'ContractTypePerPropertyType',
  localizationKey: 'Controlling::Entity.ContractTypePerPropertyType',
  fields: CONTRACTTYPEPERPROPERTYTYPE_FIELDS,
  permission: 'Controlling.ContractTypePerPropertyTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
